import * as React from 'react';
import { Tabs, Row, Col } from 'antd';
import UpdateUserProfileForm from '../UpdateUserProfileForm';
import ResetPasswordForm from '../ResetPasswordForm/ResetPasswordForm';
import CreditCardOverview from '../CreditCardRegistrationForm/CreditCardOverview';
import {
  StyleUserProfileTab,
  PageContainerRow,
  PageContainerCol,
  PageContainerColLayout,
} from './UserPrfileTab.Style';
import CenteredPageContainer from 'components/Layout/CenteredPageContainer';
import { BrowserRouter as Router, Switch, Route, NavLink, RouteComponentProps, withRouter } from 'react-router-dom';
import Form, { FormComponentProps } from 'antd/lib/form';
import { createBrowserHistory } from "history";
import CustomerBolOverview from '../CustomerBolOverview';
import AuthContext from 'Context/AuthContext';

export interface Props extends FormComponentProps, RouteComponentProps {
  children?: React.ReactNode;
}

export interface State { }

class BaseUserProfileTabbed extends React.Component<Props, State> {
  static contextType = AuthContext;
  context!: React.ContextType<typeof AuthContext>;
  constructor(props: Props) {
    super(props);
    this.profile = this.profile.bind(this);

    this.state = {};
  }

  profile() {
    const { TabPane } = Tabs;
    return (
      //for now, have to force to refresh on push when an update/confirm/delete/registration of card is made
      // <Router forceRefresh={true} >
      //force refresh is refreshing page when i move from tab to tab as well
      <Router  >
        <Switch>
          <Route
            path="/user-profile/:profile?"
            render={({ match, history }) => {
              return (
                <CenteredPageContainer title="User Profile">
                  <Row>
                    <Col
                      xl={{ span: 24, offset: 0 }}
                      lg={{ span: 24, offset: 0 }}
                      md={{ span: 24, offset: 0 }}
                      sm={{ span: 16, offset: 4 }}
                      xs={{ span: 12, offset: 6 }}
                    >
                      <Row style={{ border: "solid lightgrey 2px", borderRadius: "15px", padding: "15px 20px", marginTop: "5px" }}>
                        <StyleUserProfileTab
                          //on refresh, default to tab that url path is set to.
                          defaultActiveKey={window.location.pathname.split('/')[2] ? window.location.pathname.split('/')[2] : "account-info"}
                          tabPosition="top"
                          onChange={key => {
                            history.push(`/user-profile/${key}`);
                          }}>
                          <TabPane tab="Account Information" key="account-info">
                            <Col span={24}>
                              <UpdateUserProfileForm />
                            </Col>
                          </TabPane>

                          <TabPane tab="Reset Password" key="reset-password">
                            <Col span={24}>
                              <ResetPasswordForm />
                            </Col>
                          </TabPane>

                          <TabPane tab="Register & Verify Card" key="register-card">
                            <Col span={24}>
                              <CreditCardOverview />
                            </Col>
                          </TabPane>
                        </StyleUserProfileTab>
                      </Row>
                    </Col>
                  </Row>
                </CenteredPageContainer>
              );
            }}
          />

        </Switch>
      </Router>
    )
  }

  render() {
    return (
      this.profile()
    );
  }
}


const UserProfileTabbedWithoutRouter = Form.create<Props>({
  name: 'UpdateUserProfileForm',
})(BaseUserProfileTabbed);

const UserProfileTabbed = withRouter(UserProfileTabbedWithoutRouter);

export default UserProfileTabbed;